import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IAlertActionFieldError } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export type AttendanceSection = "doctors" | "groomers" | "all_staff";

export interface IAlertActionBody {
  date: string;
  staff_id?: string;
  section: AttendanceSection;
  alert_type: string;
  reason_code: string;
  reason_label?: string;
  note?: string;
  action_note?: string;
}

export const useAlertActionAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [fieldErrors, setFieldErrors] = useState<IAlertActionFieldError[]>([]);
  const [isSaving, setIsSaving] = useState(false);

  const execute = useCallback(
    async (clinicId: string, body: IAlertActionBody) => {
      setIsSaving(true);
      setFieldErrors([]);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios.post(`${CONFIGURATION_APIS.ALERT_ACTION_SAVE.baseURL}${clinicId}/alert-action/`, body, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        toast.success("Reason saved");
        return true;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError<{ message?: string; data?: { errors?: IAlertActionFieldError[] } }>;
          setFieldErrors(axiosError.response?.data?.data?.errors ?? []);
          toast.error(axiosError.response?.data?.message || "Could not save reason");
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        return false;
      } finally {
        setIsSaving(false);
      }
    },
    [configuration],
  );

  return { execute, fieldErrors, isSaving };
};
